import { render, staticRenderFns } from "./EmptyListInfo.vue?vue&type=template&id=cea06f60&"
import script from "./EmptyListInfo.vue?vue&type=script&lang=js&"
export * from "./EmptyListInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports